import type {PublicMethodUtils} from '@wix/document-services-types'
import type {CssStylePublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'
import {builderComponents} from '@wix/document-services-implementation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<CssStylePublicAPI> {
    const {
        extensionPublicAPI: {constants, dataManipulation, getter}
    } = publicMethodUtils

    return {
        methods: {
            components: {
                cssStyle: {
                    update: dataManipulation('components.cssStyle.update'),
                    get: getter('components.cssStyle.get'),
                    remove: dataManipulation('components.cssStyle.remove'),
                    connectToGlobalStyle: dataManipulation('components.cssStyle.connectToGlobalStyle'),
                    customCss: {
                        get: getter('components.cssStyle.customCss.get'),
                        update: dataManipulation('components.cssStyle.customCss.apply', {
                            isAsyncOperation: true,
                            asyncPreDataManipulation: builderComponents.customCssUpload
                        }),
                        remove: dataManipulation('components.cssStyle.customCss.remove')
                    },
                    scoped: {
                        remove: dataManipulation('components.cssStyle.scoped.remove')
                    }
                }
            },
            cssStyle: {
                CSS_SHORTHAND_MAPPINGS: constants('style.CSS_SHORTHAND_MAPPINGS')
            }
        }
    }
}
